var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.breaches,"items-per-page":5,"hide-default-footer":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }